"use client";

import { Grid } from "@mui/material";
import {
  JobberListCard,
  JobberPagination,
  JobberSearch,
  JobberSorting,
  JobberTable,
} from "../../../../components/MuiTable";
import CustomerModal from "../../Quotes/CustomerModal";
import "./style.css";
import { useLocation } from "react-router-dom";
import { getItem } from "../../../../utils/storage";

const Invoice = ({
  loader,
  search,
  setSearch,
  cellData,
  setIsCustomer,
  setModalSource,
  page,
  setPage,
  setRowsPerPage,
  CompanyUrl,
  countData,
  rowsPerPage,
  isCustomer,
  formik,
  lineItems,
  propertyData,
  setPropertyData,
  isProperty,
  setIsProperty,
  customersData,
  setCustomersData,
  source,
  staffData,
  dropdownOptions,
  handleDropdownSelect,
  setSortField,
  setSortOrder,
  sortOrder,
  sortField,
  tokenDecode,
  handleCustomerClick,
  customerProperties,
  isDonationMode,
}) => {
  const location = useLocation();

  const isWorker = Boolean(getItem("worker_id"));
  const canAddInvoice = isWorker
    ? Boolean(
        staffData?.Invoice?.ViewCreateAndEdit ||
          staffData?.Invoice?.ViewCreateEditAndDelete
      )
    : true;

  const handleAddInvoice = (e) => {
    e.preventDefault();
    setIsCustomer(true);
    setModalSource("Invoice");
  };

  return (
    <>
      <JobberListCard
        title="All Invoices"
        totalCount={countData}
        addButton={
          canAddInvoice
            ? {
                label: "Add Invoice",
                onClick: handleAddInvoice,
                isDonationMode,
              }
            : null
        }
        toolbar={
          <Grid className="customer d-flex gap-2 customer_searchBar searchBarOfTable">
            <JobberSorting
              triggerVariant="light"
              dropdownItems={dropdownOptions}
              placeholder="Select Status"
              onSelect={handleDropdownSelect}
            />
            <JobberSearch search={search} setSearch={setSearch} />
          </Grid>
        }
        loader={loader}
        footer={
          <JobberPagination
            totalData={countData}
            currentData={rowsPerPage}
            dataPerPage={rowsPerPage}
            pageItems={[10, 25, 50]}
            page={page}
            setPage={setPage}
            setRowsPerPage={setRowsPerPage}
          />
        }
      >
        <JobberTable
          headerData={[
            { label: "Customer Name", field: "customerData.FirstName", width: "12%" },
            {
              label: "Invoice #",
              field: "InvoiceNumber",
              width: "12%"
            },
            { label: "Address", field: "locationData.Address", width: "45%" },
            { label: "Created On", field: "CreatedAt", width: "10%" },
            { label: "Due Date", field: "DueDate", width: "9%" },
            { label: "Total Amount", field: "Total", align: "right", width: "8%" },
            {
              label: "Balance",
              field: "DueAmount",
              align: "right",
              width: "8%"
            },
            { label: "Status", field: "Status", width: "10%" },
            ...(!staffData?.Invoice?.ViewOnly
                ? [{ label: "Actions", field: "" }]
              : []),
          ]}
          mobileCardPrimaryColumnIndex={0}
          mobileCardSubtitleColumnIndex={3}
          mobileCardStatusColumnIndex={7}
          setSortField={setSortField}
          setSortOrder={setSortOrder}
          sortOrder={sortOrder}
          sortField={sortField}
          cellData={cellData}
          isNavigate={true}
          navigatePath={
            tokenDecode?.Role === "Worker"
              ? `/${CompanyUrl}/staff-member/worker-invoice-detail`
              : `/${CompanyUrl}/invoice-details`
          }
          navigats={
            location?.pathname?.includes("staff-member")
              ? ["/index", "/staff-member", "/worker-invoice"]
              : ["/index", "/invoice"]
          }
          isCollapse={false}
          page={page}
          showMobileViewDetailsButton={false}
        />
      </JobberListCard>
        <CustomerModal
          isCustomer={isCustomer}
          setIsCustomer={setIsCustomer}
          isProperty={isProperty}
          setIsProperty={setIsProperty}
          setFieldValue={formik?.setFieldValue}
          values={formik?.values}
          lineItems={lineItems}
          propertyData={propertyData}
          setPropertyData={setPropertyData}
          customersData={customersData}
          setCustomersData={setCustomersData}
          formik={formik}
          source={source}
          tokenDecode={tokenDecode}
          handleCustomerClick={handleCustomerClick}
          customerProperties={customerProperties}
        />
    </>
  );
};

export default Invoice;
